var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconOpenData = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "icon"
}, /*#__PURE__*/React.createElement("path", {
  id: "icon_2",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.5 5.25C16.5 4.83579 16.1642 4.5 15.75 4.5H8.99976L7.55463 3.05492C7.51946 3.01975 7.47177 3 7.42204 3H2.25002C1.83562 3 1.49974 3.33607 1.5 3.75047L1.50654 14.2505C1.5068 14.6645 1.84252 15 2.25657 15H15.75C16.1642 15 16.5 14.6642 16.5 14.25V5.25ZM15 13.5H2.99956V6H15V13.5Z",
  fill: "#CCE3F0"
}))));
export default SvgIconOpenData;